import { useMemo } from 'react'

export type MobilePlatform = 'ios' | 'android'

const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  (window.navigator as Navigator & { standalone?: boolean }).standalone === true

const detectPlatform = (): MobilePlatform | null => {
  const ua = window.navigator.userAgent
  if (/android/i.test(ua)) return 'android'
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios'
  return null
}

export const useMobilePlatform = (): MobilePlatform | null =>
  useMemo(() => (isStandalone() ? null : detectPlatform()), [])
